




































































































































































import Component from 'vue-class-component';
import Vue from 'vue';
import CompanyFeesCriteria from './company-fees-criteria.vue';
import * as ent from '@/entities';
import companyFeesApi from '@/api/company-fees.api';
import siteTypesApi from '@/api/site-types.api';
import { ISiteEdit, ISiteTypeDetailModel } from '@/entities';
import * as utils from '@/utils';
import { NoteType } from '@/entities/note/note.type';
import * as types from '@/store/types';
import { INote } from '@/entities/note/note.interface';
import { CompanyFeeEditModel } from './company-fee-edit-model';

@Component({
    components: {
        'company-fees-criteria': CompanyFeesCriteria
    }
})
export default class CompanyFees extends Vue {
    public items: CompanyFeeEditModel[] = null;
    public loading: boolean = false;
    public defaultType: ent.ISiteTypeDetailModel;

    public async generate(model: any) {
        if (!model || !model.typeId) {
            this.items = null;
            return;
        }
        this.loading = true;
        this.items = null;

        try {
            const [type, items] = await Promise.all([
                siteTypesApi.get(model.typeId),
                companyFeesApi.list(model.siteId, model.typeId)
            ]);
            this.defaultType = type;
            this.items = items.map((x) => new CompanyFeeEditModel(x, type));
        } finally {
            this.loading = false;
        }
    }

    public itemChange(item: CompanyFeeEditModel) {
        item.dirty = true;
        item.inProgress = true;
        companyFeesApi.update(item.getModelToUpdate()).then(() => {
            item.inProgress = false;
            //  let payload: INote = {
            //         total: 1,
            //         guid: utils.guid(),
            //         type: NoteType.Success,
            //         heading: 'Success',
            //         body: 'Operation Complete'
            //     };

            //     this.$store.dispatch(types.ADD_TEMP_NOTE, payload);
        });
    }

    public async save(item: CompanyFeeEditModel) {
        item.inProgress = true;
        try {
            await companyFeesApi.update(item.getModelToUpdate());
            item.dirty = false;
        } finally {
            item.inProgress = false;
        }
    }
}
